module.exports = __webpack_public_path__ + "static/media/pfsenseHardware.71d144c3.jpg";